/* js/components/socialShare/Xing.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	assign,
	attr,
	compute_rest_props,
	create_component,
	destroy_component,
	detach,
	exclude_internal_props,
	get_spread_object,
	get_spread_update,
	init,
	insert,
	mount_component,
	safe_not_equal,
	svg_element,
	transition_in,
	transition_out
} from "svelte/internal";

import ShareButton from './ShareButton.svelte';

function create_default_slot(ctx) {
	let svg;
	let path;

	return {
		c() {
			svg = svg_element("svg");
			path = svg_element("path");
			attr(path, "d", "M10.2 9.7l-3-5.4C7.2 4 7 4 6.8 4h-5c-.3 0-.4 0-.5.2v.5L4 10 .4 16v.5c0 .2.2.3.4.3h5c.3 0 .4 0 .5-.2l4-6.6v-.5zM24 .2l-.5-.2H18s-.2 0-.3.3l-8 14v.4l5.2 9c0 .2 0 .3.3.3h5.4s.3 0 .4-.2c.2-.2.2-.4 0-.5l-5-8.8L24 .7V.2z");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			attr(svg, "viewBox", "0 0 24 24");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path);
		},
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

function create_fragment(ctx) {
	let sharebutton;
	let current;

	const sharebutton_spread_levels = [
		{
			class: "ssbc-button--xing " + /*classes*/ ctx[1]
		},
		/*$$restProps*/ ctx[3],
		{ ariaLabel: /*ariaLabel*/ ctx[0] },
		{ href: /*href*/ ctx[2] }
	];

	let sharebutton_props = {
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	for (let i = 0; i < sharebutton_spread_levels.length; i += 1) {
		sharebutton_props = assign(sharebutton_props, sharebutton_spread_levels[i]);
	}

	sharebutton = new ShareButton({ props: sharebutton_props });

	return {
		c() {
			create_component(sharebutton.$$.fragment);
		},
		m(target, anchor) {
			mount_component(sharebutton, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const sharebutton_changes = (dirty & /*classes, $$restProps, ariaLabel, href*/ 15)
			? get_spread_update(sharebutton_spread_levels, [
					dirty & /*classes*/ 2 && {
						class: "ssbc-button--xing " + /*classes*/ ctx[1]
					},
					dirty & /*$$restProps*/ 8 && get_spread_object(/*$$restProps*/ ctx[3]),
					dirty & /*ariaLabel*/ 1 && { ariaLabel: /*ariaLabel*/ ctx[0] },
					dirty & /*href*/ 4 && { href: /*href*/ ctx[2] }
				])
			: {};

			if (dirty & /*$$scope*/ 64) {
				sharebutton_changes.$$scope = { dirty, ctx };
			}

			sharebutton.$set(sharebutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(sharebutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(sharebutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(sharebutton, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const omit_props_names = ["title","url","ariaLabel","class"];
	let $$restProps = compute_rest_props($$props, omit_props_names);
	let { title } = $$props;
	let { url } = $$props;
	let { ariaLabel = 'Share on Xing' } = $$props;
	let { class: classes = '' } = $$props;
	let href;

	$$self.$$set = $$new_props => {
		$$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
		$$invalidate(3, $$restProps = compute_rest_props($$props, omit_props_names));
		if ('title' in $$new_props) $$invalidate(4, title = $$new_props.title);
		if ('url' in $$new_props) $$invalidate(5, url = $$new_props.url);
		if ('ariaLabel' in $$new_props) $$invalidate(0, ariaLabel = $$new_props.ariaLabel);
		if ('class' in $$new_props) $$invalidate(1, classes = $$new_props.class);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*url, title*/ 48) {
			$: $$invalidate(2, href = encodeURI(`https://www.xing.com/app/user?op=share;url=${url};title=${title}`));
		}
	};

	return [ariaLabel, classes, href, $$restProps, title, url];
}

class Xing extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { title: 4, url: 5, ariaLabel: 0, class: 1 });
	}
}

export default Xing;